import { useEffect, useState } from 'preact/hooks';
import { Link } from 'preact-router';
import render from 'preact-render-to-string';
import Table from "../components/ui/Table";
import Select from '../components/ui/Select';
import SelectAuto from '../components/ui/SelectAuto';
import Modal from '../components/ui/Modal';
import useTable from '../context/TableContext';
import useApp from '../context/AppContext';
import useModal from '../hooks/useModal';
import { eventType, typeArray } from '../consts';

export default function EventsList() {
    const { animals, categories } = useApp();
    const { isModalShowing, toggleModal } = useModal();
    const {
        tableData,
        tableDataDisplay,
        tableActions,
        setTableActions,
        handleDisplaying,
        setFilter,
        cancelFilters
    } = useTable();
    const [isLoading, setLoading] = useState(true);
    const [selectedType, setSelectedType] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedAnimal, setSelectedAnimal] = useState(null);
    const [animalList, setAnimalList] = useState([]);
    const [animalNameFilter, setAnimalNameFilter] = useState("");

    const columns = [
        { label: "Date", accessor: "dateApi", sortable: true },
        { label: "Animal", accessor: "animal", sortable: true },
        { label: "Type", accessor: "type", sortable: true },
        { label: "Terrain", accessor: "location", sortable: false },
        { label: "Notes", accessor: "notes", sortable: true },
    ];

    function getAnimal(id) {
        return animals ? animals.find(animal => parseInt(animal.id) === parseInt(id)) : null;
    }

    function getLinkEventByType(type, id) {
        let urlBase = "";
        switch (type) {
            case '1':
                urlBase = "/event-movement/";
                break;
            case '2':
                urlBase = "/event-marker/";
                break;
            case '3':
                urlBase = "/event-weight/";
                break;
            case '4':
                urlBase = "/event-other/";
                break;
            case '5':
                urlBase = "/event-farrow/";
                break;
            case '6':
                urlBase = "/event-exit/";
                break;
            default:
                break;
        }
        // No link on marker events
        return type != 2 ? render(<Link href={urlBase + id}>{eventType[type]}</Link>) : eventType[type];
    }

    function cellFormat(value, accessor, data) {
        let str = value;
        switch (accessor) {
            case 'dateApi':
                str = new Date(data.dateApi).toLocaleDateString();
                break;
            case 'animal': {
                const animal = getAnimal(data.animalId);
                if (animal) {
                    str = render(<Link href={'/animal/' + data.animalId}>{data.animalName}</Link>);
                    animal.markers.forEach(marker => {
                        str += '<div class="marker-shape" style="background-color:' + marker.color + '"></div>';
                    })
                    if (data.animalExited) {
                        str = '<div class="exited">' + str + '</div>';
                    }
                }
                break;
            }
            case 'type':
                str = getLinkEventByType(value, data.id);
                break;
            case 'location':
                str = <Link className="nav-animal" href={'/location/' + data.locationId}><div dangerouslySetInnerHTML={{ __html: data.locationName }} /></Link>
                str = render(str);
                break;
            case 'notes':
                str = value.substring(0, 60);
                if (str.length < value.length) str += '... ';
                break;
            default:
                break;
        }
        return str;
    }

    useEffect(() => {
        const filteredFields = tableActions.events.filteredFields;
        setSelectedType(filteredFields.type);
        setSelectedCategory(filteredFields.categoryId);
        setSelectedLocation(filteredFields.locationId);
        setSelectedAnimal(filteredFields.animalId);
        setLoading(false);
        // On unmount
        return () => {
            sessionStorage.scrollTopEventList = sessionStorage.scrollTop;
        }
    }, []);

    useEffect(() => {
        if (!isLoading) {
            const scrollTop = sessionStorage.scrollTopEventList || 0;
            document.documentElement.scrollTo(0, scrollTop);
        }
    }, [isLoading]);

    useEffect(() => {
        handleDisplaying('events');
    }, [tableData]);

    const buttonModalFilterCancel = {
        className: "btn-secondary",
        text: "Annuler les filtres",
        onClick: () => {
            cancelFilters('events');
            setSelectedType('');
            setSelectedCategory('');
            setSelectedLocation('');
            setSelectedAnimal('');
            setAnimalList([]);
            setAnimalNameFilter('');
            toggleModal('ModalFilter');
        }
    }

    const buttonModalFilter = {
        className: "btn-primary",
        onClick: () => {
            setTableActions({
                ...tableActions,
                events: {
                    ...tableActions.events,
                    pager: {
                        ...tableActions.events.pager,
                        page: 1
                    }
                }
            })
            toggleModal('ModalFilter');
        },
        text: "Filtrer"
    }

    const handleSelectChange = (e, field) => {
        const value = e.target.value;
        setFilter('events', field, value);
        switch (field) {
            case 'type':
                setSelectedType(value);
                break;
            case 'categoryId':
                setSelectedCategory(value);
                break;
            case 'locationId':
                setSelectedLocation(value);
                break;
            case 'animalId':
                setSelectedAnimal(value);
                break;
        }
    }

    const handleAnimalFilterInSelect = (e) => {
        const value = e.target.value;
        setAnimalNameFilter(e.target.value);
        const animalListFiltered = animals.filter((animal) => {
            const animalName = animal.name.substring(0, value.length);
            return value.toLowerCase() == animalName.toLowerCase()
        })
        if (typeof animalListFiltered != "undefined") {
            setAnimalList(animalListFiltered);
        }
    }

    if (isLoading) {
        return <div className="text-center pt-5">Loading events ...</div>;
    }

    return (
        <div>
            <Modal isShowing={isModalShowing} hide={() => toggleModal('ModalFilter')} title="Choisissez une action" id="ModalFilter" buttons={[buttonModalFilterCancel, buttonModalFilter]}>
                <div>
                    <Select id="type" label="Filtrer par type" value={selectedType} onChange={(e) => handleSelectChange(e, 'type')}>
                        <option value="">- Choisissez -</option>
                        {
                            typeArray.map((type, id) => {
                                return (
                                    <option key={id} selected={selectedType === id && true || false} value={id}>{type}</option>
                                )
                            })
                        }
                    </Select>
                    <Select id="category" label="Filtrer par catégorie" value={selectedCategory} onChange={(e) => handleSelectChange(e, 'categoryId')}>
                        <option value="">- Choisissez -</option>
                        {
                            categories && categories.map((category) => {
                                return (
                                    <option key={category.id} selected={selectedCategory === category.id && true || false} value={category.id}>{category.name}</option>
                                )
                            })
                        }
                    </Select>
                    <Select id="location" label="Filtrer par terrain" value={selectedLocation} onChange={(e) => handleSelectChange(e, 'locationId')}>
                        <option value="">- Choisissez -</option>
                        {
                            tableData && tableData['locations'].map((location) => {
                                return (
                                    <option key={location.id} selected={selectedLocation === location.id && true || false} value={location.id}>{location.fullName}</option>
                                )
                            })
                        }
                    </Select>
                    <SelectAuto id="animal" label="Filtrer par animal" value={selectedAnimal} onChange={(e) => handleSelectChange(e, 'animalId')} filter={animalNameFilter} onFilter={handleAnimalFilterInSelect} >
                        <option value="">- Choisissez -</option>
                        {
                            animalList && animalList.map((animal) => {
                                return (
                                    <option key={animal.id} selected={selectedAnimal === animal.id && true || false} value={animal.id}>{animal.name}</option>
                                )
                            })
                        }
                    </SelectAuto>
                </div>
            </Modal>
            <Table id="events" caption="Historique" columns={columns} selectable={false} cellFormat={cellFormat} filter={{ filterable: true, toggleModal: () => toggleModal('ModalFilter') }} pagination={true} />
        </div>
    );
}